// extracted by mini-css-extract-plugin
export default {"root":"styles_root__74Ktp","title":"styles_title__Zr2jj","control":"styles_control__+suL7","mobileImage":"styles_mobileImage__tY1Yz","desktopImage":"styles_desktopImage__QTpXP"};